import React from "react";
import LABEL_ADMIN_INFO_FORM from "./label-admin-info-form";
import BsForm from "components/form/BsForm";
import {fetchBoUser} from "core/actions/admin-actions";
import {connect} from "react-redux";

class LabelAdminInfoTab extends React.Component {

  constructor(props) {
    super(props);
    this.formRef = React.createRef();
    this.props.fetchBoUser(this.props.match.params.userId);
  }

  render() {
    if (this.props.currentAdmin) {
      const formConfig = {
        ...LABEL_ADMIN_INFO_FORM,
        title: {
          back: {
            url: '/label/' + this.props.match.params.labelId + '/admins',
            history: this.props.history,
            location: this.props.location
          }
        }
      };

      return (
        <div className="bs-form-container">
          <BsForm
            config={formConfig}
            formData={this.props.currentAdmin}
            disabled={true}/>
        </div>
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = (state) => {
  return {
    currentAdmin: state.admin.currentAdmin
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchBoUser: (userId) => {
      dispatch(fetchBoUser(userId));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LabelAdminInfoTab);
